import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGlobalError,deleteGlobalError } from '../actions';
import { usePrevious } from './usePrevious';


// Removes values from store when element unmounts
export function useValidation(validate,value,path,id) {

  const [error, setError] = useState('');

  const prevValue = usePrevious(value);

  const dispatch = useDispatch();
  const globalError = useSelector(state => state.errors[id])

  // Respond to validate event
  useEffect(() => {
    window.addEventListener('validate', validate)
    return () => window.removeEventListener('validate', validate)
  })


  // Keep store up-to-date
  useEffect(() => {
    if (error && (!globalError || globalError !== path)) {
      dispatch(setGlobalError(id,path))
    } else if (!error && globalError) {
      dispatch(deleteGlobalError(id))
    }
  }, [dispatch,error,globalError,id,path])


  // Revalidate when value changes
  // (If error is corrected and then made incorrect again, it is ignored until next validation event)
  useEffect(() => {
    if (error && prevValue !== value) {
      validate()
    }
  }, [error,prevValue,validate,value])


  return [error,setError]
}